import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
} from 'reactstrap';
import parse from "html-react-parser";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

const DynamicFlowTemplate = ({ locale, visible, toggle, getTemplateData, dynamicFlowList }) => {
    const [dynamicFlowTemplateList, setDynamicFlowTemplateList] = useState([]);
    const [id, setId] = useState("");

    useEffect(() => {
        setDynamicFlowTemplateList(dynamicFlowList);
    }, [locale, dynamicFlowList]);

    const toggleShowmore = (index, isMore) => {
        const values = [...dynamicFlowTemplateList];
        values[index].showMore = !isMore;
        setDynamicFlowTemplateList(values);
    }

    const checkedFlow = (e) => {
        if (e.target.checked) {
            setId(e.target.value);
        }
        if (!e.target.checked) {
            setId("");
        }
    }

    const ImportTempate = () => {
        var data = dynamicFlowTemplateList.filter(l => l.id == id);
        if (data.length > 0) {
            getTemplateData(data[0]);
            toggle();
        }
    }
    return (<Fragment>
        <Modal isOpen={visible} toggle={() => toggle()} size="lg">
            <ModalHeader toggle={() => toggle()}>
                Dynamic ConversationFlow Templates
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx md="12">
                        {dynamicFlowTemplateList && dynamicFlowTemplateList.length > 0 &&
                            dynamicFlowTemplateList.map((k, i) => (
                                <Row className="mb-3">
                                    <Colxx md={8}>
                                        <h5>{k.name}</h5>
                                        {k.instructions.length > 100 && k.showMore === false ?
                                            <Fragment>
                                                <span>{parse(k.instructions.substring(0, 100)) + "..."}</span>
                                                <a style={{
                                                    fontWeight: "600",
                                                    marginLeft: "15px"
                                                }} onClick={() => toggleShowmore(i, k.showMore)}>See More</a>
                                            </Fragment>
                                            :
                                            <span>{parse(k.instructions)}</span>
                                        }
                                        {k.instructions.length > 100 && k.showMore === true &&
                                            <Fragment>
                                                <span>{parse(k.instructions)}</span>
                                                <a style={{
                                                    fontWeight: "600",
                                                    marginLeft: "15px"
                                                }} onClick={() => toggleShowmore(i, k.showMore)}>See Less</a>
                                            </Fragment>}
                                    </Colxx>
                                    <Colxx md={4}>
                                        <CustomInput
                                            key={k.id}
                                            type="radio"
                                            id={i}
                                            value={k.id}
                                            checked={
                                                k.id === id ? true : false
                                            }
                                            onChange={(e) => checkedFlow(e)}
                                        />
                                    </Colxx>
                                </Row>
                            ))}
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => ImportTempate()}>
                    Import
                </Button>
                <Button color="secondary" onClick={() => toggle()}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>)
}
export default DynamicFlowTemplate;